import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-marine-insurance-card',
  templateUrl: './marine-insurance-card.component.html',
  styleUrls: ['./marine-insurance-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceCardComponent {
  @Input() public cardTitle: string;
  @Input() public cardHint: string;
  @Input() public cardHintTitle: string;
  @Input() public isCanEdit: boolean;
  @Input() public isDashed: boolean;
  @Input() public isShowAddIcon: boolean;
  @Input() public isFullHeight: boolean;
  @Input() public isShowAnimation: boolean;
  @Input() public isErrored: boolean;
  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();
}
